import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { AxiosRequestConfig } from 'axios'

export interface TerminalListReq {
  /** 分组id */
  group_id: number
  /** 顺序，true-正序，false-逆序 */
  asc?: boolean
  /** 每页数量 */
  limit: number
  key_word?: string
  /** 当前页 */
  page: number
  /** 排序字段 */
  sort?: string
  /** 系统类型 */
  system_types?: number[]
  is_auth: boolean
  permission_names: string[]
}

export interface TerminalItem {
  /** 终端设备id */
  device_id: string
  /** 分组id */
  group_id: number
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 操作系统 */
  system_name: string
  /** 终端登录状态,1-在线，2-离线 */
  login_status: number
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
}

export interface TerminalListRes {
  total: number,
  terminal_list: TerminalItem[]
}

@Injectable()
export class TerminalAuthService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (data: TerminalListReq, url, config: AxiosRequestConfig = {}) {
    return this.http.post<TerminalListRes>(url, data, config)
  }
}
